<template>
    <div style="display: flex; align-items: center; justify-content: center;">
        <v-container fluid>
            <v-layout row>
                <v-flex style="display: flex; align-items: center; justify-content: center;">
                    <v-card class="card--flex-toolbar" style="width: 700px;">
                        <v-toolbar card dense color="primary" dark>
                        <v-toolbar-title>Quarterly sales recommendation gains</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon>
                            <v-icon>info</v-icon>
                        </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text>
                        <v-layout row>
                            <v-flex xs12 style="display: flex; align-items: center; justify-content: center;">
                                <v-chart :options="options" style="width: 700px; height: 400px;"/>
                            </v-flex>
                        </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import numbro from 'numbro'

export default {
  components: {
    'v-chart': ECharts
  },
  computed: {
      
  },
  methods: {
      formatTooltip: function (params) {
          var tooltip = ''
          for (let index = params.length-1; index >= 0; index--) {
              const param = params[index]
              if (param.dataIndex === 4 && param.value != 0) {
                  tooltip += `
                    <b style="color: ${param.color}">▶</b>
                    <b>${param.seriesName}</b>:
                    <span style="color: lightblue; font-size: 16px;">${this.formatCurrency(param.value)}</span>
                    <br>
                `   
              } else if (param.dataIndex != 4 && param.value != 0) {
                  tooltip += `
                    <b style="color: ${param.color}">▶</b>
                    <b>${param.seriesName}</b>:
                    <span style="color: lightblue; font-size: 16px;">${this.formatCurrency(param.value)}</span>
                    <br>
                `   
              }
          } 
          return tooltip
      },
      formatCurrency: function (value) {
          return numbro(value).formatCurrency({
                average: true,
                mantissa: 1,
                optionalMantissa: true
            })
      },
      formatPercentage: function (value) {
          if (value.value == 0) {
              return ''
          } else {
              return `${value.value / 10000000}%`
          }   
      },
      formatNegPercentage: function (value) {
          var str = this.formatPercentage(value)
          if (str.length > 0) {
              return '-' + this.formatPercentage(value)
          } else {
              return str
          }
      }
  },
  data () {
    return {
        options: {
            tooltip : {
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: this.formatTooltip
            },
            xAxis : [
                {
                    type : 'category',
                    data : ['Q1','Q2','Q3','Q4', 'Total'],
                    axisLabel: {
                        color: 'black',
                        fontFamily: 'Roboto,sans-serif',
                        fontSize: '14'
                    }
                }
            ],
            yAxis : [
                {
                    type : 'value',
                    name: 'Sales',
                    nameTextStyle: {
                        color: 'black',
                        fontFamily: 'Roboto,sans-serif',
                        fontSize: '16'
                    },
                    axisLabel: {
                        formatter: this.formatCurrency,
                        color: 'black',
                        fontFamily: 'Roboto,sans-serif',
                        fontSize: '12'
                    },
                    splitLine: {
                        show: false
                    }
                }
            ],
            series : [
                {
                    name:'Original',
                    type:'bar',
                    stack: 'gains',
                    itemStyle: {
                        color: '#58ADD4',  
                    },
                    data:[120000000, 132000000, 101000000, 134000000, 0]
                },
                {
                    name:'Gain',
                    type:'bar',
                    stack: 'gains',
                    itemStyle: {
                        color: '#274867',  
                    },
                    label: {
                        normal: {
                            show: true,
                            textBorderColor: '#333',
                            textBorderWidth: 2,
                            fontSize: 16,
                            fontFamily: 'Roboto,sans-serif',
                            formatter: this.formatPercentage
                        }
                    },
                    data:[20000000, 10000000, 0, 5000000, 0]
                },
                {
                    name:'Loss',
                    type:'bar',
                    stack: 'gains',
                    itemStyle: {
                        color: 'darkred',  
                    },
                    label: {
                        normal: {
                            show: true,
                            textBorderColor: '#333',
                            textBorderWidth: 2,
                            fontSize: 16,
                            fontFamily: 'Roboto,sans-serif',
                            formatter: this.formatNegPercentage,
                            prepend: '-'
                        }
                    },
                    data:[0, 0, 10000000, 0, 0]
                },
                {
                    name:'Original',
                    type:'bar',
                    stack: 'gains',
                    itemStyle: {
                        color: '#58ADD4',  
                    },
                    data:[0, 0, 0, 0, 400000000]
                }
                ,
                {
                    name:'Gain',
                    type:'bar',
                    stack: 'gains',
                    itemStyle: {
                        color: '#274867',  
                    },
                    label: {
                        normal: {
                            show: true,
                            textBorderColor: '#333',
                            textBorderWidth: 2,
                            fontSize: 20,
                            fontFamily: 'Roboto,sans-serif',
                            formatter: this.formatPercentage
                        }
                    },
                    data:[0, 0, 0, 0, 100000000]
                }
            ]
        }
    }
  }
}
</script>

<style>
    .echarts {
        width: 100%;
        height: 100%;
    }
</style>
